import $ from 'jquery';
import LocationsMap from './classes/locations-map';

export default class Mapz {
	constructor(mapElement) {
		this.locationsMap = new LocationsMap(mapElement);
	}

	init() {
		this.locationsMap.init();
	}
}

$(document).ready(() => {
	const mapElement = document.getElementById('map');
	if (mapElement) {
		const mapz = new Mapz(mapElement);
		mapz.init();
	}
});
